var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySubscriptionTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 136,
    viewBox: "0 0 143 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 136C104.777 136 135 105.553 135 68C135 30.447 104.777 0 67.5 0C30.2231 0 0 30.447 0 68C0 105.553 30.2231 136 67.5 136Z",
    fill: "#F7F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117 25C118.655 25 120 23.4308 120 21.5C120 19.5692 118.655 18 117 18C115.345 18 114 19.5692 114 21.5C114 23.4308 115.345 25 117 25Z",
    fill: "#DEEBF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.375 18H139.625C141.487 18 143 19.5692 143 21.5C143 23.4308 141.487 25 139.625 25H128.375C126.513 25 125 23.4308 125 21.5C125 19.5692 126.513 18 128.375 18Z",
    fill: "#EFF5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.564 127.255C38.1719 127.031 38.8139 126.734 39.3082 126.297C39.8934 125.782 40.132 125.121 40.2911 124.426C40.4956 123.53 40.5808 122.578 40.8308 121.681C40.9217 121.345 41.0978 121.222 41.1774 121.166C41.3705 121.026 41.5637 120.987 41.7455 121.004C41.9614 121.02 42.2625 121.104 42.4557 121.485C42.4841 121.541 42.5182 121.62 42.5466 121.737C42.5636 121.822 42.575 122.079 42.5977 122.186C42.6432 122.449 42.6829 122.712 42.7227 122.975C42.8477 123.855 42.9159 124.6 43.3079 125.407C43.8362 126.505 44.3646 127.171 45.0862 127.468C45.7793 127.754 46.6144 127.703 47.6769 127.474C47.7791 127.446 47.8757 127.429 47.978 127.407C48.4439 127.323 48.8927 127.642 48.9836 128.124C49.0745 128.605 48.7791 129.076 48.3132 129.182C48.2166 129.205 48.12 129.227 48.0291 129.244C46.5917 129.614 44.9328 130.93 43.9669 132.079C43.6715 132.431 43.234 133.429 42.7909 134.062C42.4614 134.527 42.0921 134.835 41.7853 134.947C41.5751 135.019 41.4046 135.008 41.2569 134.969C41.0467 134.913 40.8706 134.795 40.7399 134.611C40.666 134.51 40.5979 134.37 40.5694 134.196C40.5524 134.112 40.5524 133.899 40.5524 133.798C40.4615 133.473 40.3536 133.16 40.2683 132.835C40.0752 132.056 39.7002 131.563 39.2514 130.913C38.8309 130.303 38.3821 129.922 37.7174 129.614C37.6322 129.591 36.939 129.418 36.6947 129.317C36.3368 129.171 36.1664 128.919 36.1039 128.785C35.9959 128.561 35.9902 128.359 36.0073 128.196C36.0357 127.95 36.1436 127.743 36.3311 127.575C36.4448 127.468 36.6209 127.367 36.8538 127.317C37.0356 127.278 37.5072 127.255 37.5754 127.255H37.564ZM41.6375 125.989C41.6716 126.062 41.7057 126.141 41.7398 126.213C42.5125 127.821 43.3817 128.717 44.4328 129.149L44.4669 129.166C43.7624 129.709 43.1261 130.314 42.6375 130.897C42.4386 131.137 42.1716 131.636 41.8818 132.146C41.6205 131.266 41.1944 130.644 40.6603 129.866C40.2513 129.272 39.8195 128.824 39.2911 128.46C39.7002 128.241 40.0922 127.984 40.4331 127.687C41.0012 127.188 41.3762 126.617 41.6319 125.989H41.6375Z",
    fill: "#DEEBF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1096_30461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 43.3891C120 49.3305 115.183 54.1477 109.242 54.1477H71.5866C66.6354 54.1477 62.6211 50.1334 62.6211 45.1822C62.6211 40.2301 66.6354 36.2167 71.5866 36.2167C71.64 36.2167 71.7118 36.2342 71.7661 36.2342C72.611 32.0526 76.2856 29.0451 80.5521 29.0443C81.4986 29.0565 82.4372 29.2194 83.3311 29.5284C85.5392 24.3058 90.9745 21.2117 96.592 21.9795C102.21 22.7474 106.615 27.1864 107.341 32.81C107.968 32.6953 108.604 32.6349 109.242 32.6305C115.183 32.6305 120 37.4468 120 43.3891Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7931 104.352H78.7586C79.7489 104.352 80.5517 103.549 80.5517 102.559V97.1797H51.8621V98.9728H44.6897V97.1797H16V102.559C16 103.549 16.8029 104.352 17.7931 104.352Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9652 64.9026V97.1785H19.5859V64.9026C19.5921 62.9248 21.1943 61.3225 23.1721 61.3164H73.379C75.3569 61.3225 76.9591 62.9248 76.9652 64.9026Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9651 64.9026V97.1785H31.3486C45.8992 87.7507 58.4658 75.5684 68.3401 61.3164H73.3789C75.3567 61.3225 76.959 62.9248 76.9651 64.9026Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6895 97.1797H51.8619V98.9728H44.6895V97.1797Z",
    fill: "#EFF5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.069 100.766C102.069 102.746 100.463 104.352 98.4827 104.352C96.5022 104.352 94.8965 102.746 94.8965 100.766C94.8965 98.7854 96.5022 97.1797 98.4827 97.1797C100.463 97.1797 102.069 98.7854 102.069 100.766Z",
    fill: "#DEEBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6904 59.5234H100.277V63.1096H96.6904V59.5234Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6904 66.6953H100.277V70.2815H96.6904V66.6953Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6904 73.8672H100.277V77.4534H96.6904V73.8672Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6904 81.0391H100.277V84.6253H96.6904V81.0391Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6904 88.2148H100.277V91.8011H96.6904V88.2148Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9316 98.9727H89.5178V102.559H85.9316V98.9727Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4834 77.4531H50.0696V81.0393H46.4834V77.4531Z",
    fill: "#EFF5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2422 77.4531H60.8284V81.0393H57.2422V77.4531Z",
    fill: "#EFF5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7246 77.4531H39.3108V81.0393H35.7246V77.4531Z",
    fill: "#EFF5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4828 95.3867C95.5121 95.3867 93.1035 97.7953 93.1035 100.766C93.1035 103.737 95.5121 106.145 98.4828 106.145C101.454 106.145 103.862 103.737 103.862 100.766C103.862 97.7953 101.454 95.3867 98.4828 95.3867ZM98.4828 102.559C97.4926 102.559 96.6897 101.756 96.6897 100.766C96.6897 99.7758 97.4926 98.9729 98.4828 98.9729C99.4731 98.9729 100.276 99.7758 100.276 100.766C100.276 101.756 99.4731 102.559 98.4828 102.559Z",
    fill: "#6FAEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 43.3872C120 49.3286 115.183 54.1458 109.241 54.1458H77.8086C88.2511 46.6792 97.5537 37.7338 105.422 27.5898C106.444 29.1641 107.099 30.9467 107.341 32.8081C107.967 32.6934 108.604 32.6329 109.241 32.6286C115.183 32.6286 120 37.4449 120 43.3872Z",
    fill: "#6FAEDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1096_30461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(16 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySubscriptionTable);
export default __webpack_public_path__ + "static/media/EmptySubscriptionTable.4826cd527b46e0e5ef70d4a1fff01ba5.svg";
export { ForwardRef as ReactComponent };